import { render, staticRenderFns } from "./Acknowledgements.vue?vue&type=template&id=6d6d2694&"
import script from "./Acknowledgements.vue?vue&type=script&lang=js&"
export * from "./Acknowledgements.vue?vue&type=script&lang=js&"
import style0 from "./Acknowledgements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports